import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ImageUploading from "react-images-uploading";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ReactQuillTextEditor from "../../components-react/inputs/ReactQuillTextEditor";
import { convertBlobToFile } from "../../common-data/Conversions";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { fetchAIGeneratedBlogsData } from "../../../redux/ad-blog-reducers/blogSlice";
import Loader from "../../ui/Loader";
import { currentMonthCurrentDate } from "../../common-data/Converts";
import MultiSelect from "../../components-react/MultiSelect";

function validateAIForm(formValues, formImages) {
  let errors = {};

  if (!formValues.blogTopic) {
    errors.blogTopic = "required";
  }

  if (formValues.selectedBlogCategories?.length === 0) {
    errors.selectedBlogCategories = "required";
  }

  if (!formValues.blogTitle) {
    errors.blogTitle = "required";
  }

  if (!formValues.blogContent) {
    errors.blogContent = "required";
  }

  if (formImages.blogImages?.length === 0) {
    errors.blogImages = "required";
  }

  return errors;
}

const BlogFormAIGenerated = ({
  userInfoData,
  allBlogCategories,
  handleAdd,
  isSubmit,
  setIsSubmit,
  setModValues,
  setIsDisableSave,
}) => {
  const dispatch = useDispatch();
  const { aiGeneratedBlog, aiGeneratedBlogLoading, aiGeneratedBlogError } =
    useSelector((state) => state.blog);
  const { loading } = useSelector((state) => state.postApi);

  const forminitials = {
    blogTopic: "",
    selectedBlogCategories: [],
    blogTitle: "",
    blogContent: "",
    blogDate: "",
    isActive: true,
    blogImages: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const imgVdoInitials = {
    blogImages: [],
  };
  const [formImages, setFormImages] = useState(imgVdoInitials);
  const [formErrors, setFormErrors] = useState({});
  const [aiGeneratedData, setAiGeneratedData] = useState(null);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeTextInput = async (content, fieldName) => {
    setIsSubmit(false);
    const TOKEN = userInfoData?.token;

    const imageElements = content.match(/<img.*?src="(.*?)".*?>/g);

    if (imageElements) {
      for (let imgTag of imageElements) {
        const imageUrl = imgTag.match(/src="(.*?)"/)[1];

        const isBlobUrl = imageUrl.includes("blob:");
        const isBase64 = imageUrl.startsWith("data:image/");

        if (isBlobUrl) {
          try {
            const file = await convertBlobToFile(imageUrl);
            const response = await dispatch(
              uploadImage({ file, TOKEN })
            ).unwrap();

            if (response && response.image_url) {
              content = content.replace(imageUrl, response.image_url);
            }
          } catch (error) {
            console.error("Image upload failed:", error);
          }
        } else if (isBase64) {
          try {
            const byteCharacters = atob(imageUrl.split(",")[1]);
            const byteArray = new Uint8Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }

            const file = new Blob([byteArray], { type: "image/png" });

            const response = await dispatch(
              uploadImage({ file, TOKEN })
            ).unwrap();

            if (response && response.image_url) {
              content = content.replace(imageUrl, response.image_url);
            }
          } catch (error) {
            console.error("Base64 image upload failed:", error);
          }
        }
      }
    }

    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);

    if (imageList.length > 0) {
      const image = imageList[0]; 

      setFormImages((prevImages) => ({
        ...prevImages,
        [name]: [image], 
      }));

      fetch(image?.data_url)
        .then((res) => res.blob())
        .then((blob) => {
          const file = new File([blob], "filename.jpeg", {
            type: "image/jpeg",
          });
          handleUploadImage(file, name);
        });
    } else {
      setFormImages((prevImages) => ({
        ...prevImages,
        [name]: [],
      }));

      setFormValues((prevValues) => ({
        ...prevValues,
        [name]: "",
      }));
    }
  };

  const handleImageRemove = (index) => {
    setFormImages((prevImages) => ({
      ...prevImages,
      blogImages: [],
    }));

    setFormValues((prevValues) => ({
      ...prevValues,
      blogImages: "",
    }));
  };

  const handleUploadImage = async (file, name) => {
    setIsSubmit(false);

    const TOKEN = userInfoData?.token;

    try {
      const actionResult = dispatch(uploadImage({ file, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        setFormValues((prev) => ({
          ...prev,
          [name]: result.payload.image_url || "",
        }));

        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("Image Upload ERROR => ", error);
    }
  };

  function handleClearGenerateBlog() {
    const handleConfirm = async () => {
      setAiGeneratedData(null);
      setFormImages(imgVdoInitials);
      setFormValues(forminitials);
    };

    showConfirmAlert(
      handleConfirm,
      `All The Generated Data Will Be Clear And You Have To Generate The Blog Again!`,
      "No",
      "Yes"
    );
  }

  function handleGenerateBlog() {
    if (formValues.blogTopic) {
      const filters = {
        topic: formValues.blogTopic,
      };

      getAIGeneratedBlogs(filters);
    } else {
      toast.error("Select Category!");
    }
  }

  function getAIGeneratedBlogs(filters) {
    dispatch(
      fetchAIGeneratedBlogsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFormErrors(validateAIForm(formValues, formImages));
  }, [formValues, formImages]);

  useEffect(() => {
    if (
      aiGeneratedBlog?.status &&
      aiGeneratedBlog?.data &&
      !aiGeneratedBlogLoading &&
      !aiGeneratedBlogError
    ) {
      setAiGeneratedData(aiGeneratedBlog.data);
    } else {
      setAiGeneratedData(null);
      console.error(aiGeneratedBlogError || "Something went wrong!");
      return;
    }
  }, [aiGeneratedBlog, aiGeneratedBlogLoading, aiGeneratedBlogError]);

  useEffect(() => {
    if (aiGeneratedData && formValues.blogTopic) {
      const { content, coverImage, title } = aiGeneratedData;

      setFormValues((prevs) => ({
        ...prevs,
        blogTitle: title || "",
        blogContent: content || "",
        blogImages: coverImage || "",
      }));

      setFormImages((prevs) => ({
        ...prevs,
        blogImages: coverImage ? [{ data_url: coverImage }] : [],
      }));

      setIsDisableSave(false);
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        blogTitle: "",
        blogContent: "",
        blogImages: "",
      }));

      setFormImages((prevs) => ({
        ...prevs,
        blogImages: [],
      }));
      setIsDisableSave(true);
    }
  }, [aiGeneratedData, formValues.blogTopic]);

  useEffect(() => {
    if (!formValues.blogTopic) {
      setAiGeneratedData(null);
    }
  }, [formValues.blogTopic]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const blogCats = formValues.selectedBlogCategories.map(
        (blog) => blog.value
      );

      const userData = {
        title: formValues.blogTitle || "",
        added_by: userInfoData?.uid || userInfoData?.user_id || "",
        article_images: [formValues.blogImages || ""],
        article_category: blogCats,
        // article_category: [formValues.selectedBlogCategories?.value || ""],
        content: formValues.blogContent || "",
        blog_date: formValues.blogDate || "",
        status: formValues.isActive ? 1 : 0,
      };

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(handleConfirm, `Add Blog`, "Edit Form", "Submit Form");
    }
  }, [isSubmit, formErrors]);

  console.log("formValues.blogImages=> ", formValues.blogImages);

  return (
    <form className="formContainer form-input-multi mb30">
      <div className="formInputsGrid fourGridSystem">
        <div className="formInputBox span2">
          <label htmlFor="blogTopic" className={`formInputLabel`}>
            blog topic <span className="required">*</span>
          </label>

          <input
            type="text"
            className={`formInput ${
              formValues.blogTopic ? "date-has-value" : ""
            } ${formErrors?.blogTopic ? "formError" : ""}`}
            name="blogTopic"
            placeholder="Enter Blog Topic"
            value={formValues.blogTopic}
            onChange={onChangeInput}
            disabled={aiGeneratedData || aiGeneratedBlogLoading}
          />
        </div>

        {aiGeneratedData && (
          <>
            <div className="formInputBox span2">
              <label
                htmlFor="selectedBlogCategories"
                className={`formInputLabel`}
              >
                blog category <span className="required">*</span>
              </label>

              <div className="input-add-btn flexBetween">
                <div
                  className={`commonWrapper no-border multi-select ${
                    formErrors.selectedBlogCategories ? "error" : ""
                  }`}
                >
                  <MultiSelect
                    options={
                      allBlogCategories?.length > 0 ? allBlogCategories : []
                    }
                    state={formValues.selectedBlogCategories}
                    setState={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedBlogCategories")
                    }
                    // isDisable={aiGeneratedData || aiGeneratedBlogLoading}
                  />
                </div>
                {/* <div
                  className={`commonWrapper ${
                    formErrors.selectedBlogCategories ? "formError" : ""
                  }`}
                >
                  <SelectDropdown
                    options={
                      allBlogCategories?.length > 0 ? allBlogCategories : []
                    }
                    selectedOption={formValues.selectedBlogCategories}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedBlogCategories")
                    }
                    name="Exercise Per Week"
                    isDisable={aiGeneratedData || aiGeneratedBlogLoading}
                  />
                </div> */}

                <button
                  type="button"
                  className="btn btn-dark extraBtn"
                  style={{
                    minWidth: "150px",
                    height: "60px",
                    textTransform: "capitalize",
                  }}
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      cardName: "add",
                    }))
                  }
                >
                  Add New
                </button>
              </div>
            </div>

            <div className="formInputBox">
              <label htmlFor="blogTitle" className={`formInputLabel`}>
                blog title <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Blog Title"
                className={`formInput ${
                  formErrors?.blogTitle ? "formError" : ""
                }`}
                name="blogTitle"
                value={formValues.blogTitle}
                onChange={onChangeInput}
              />
            </div>

            <div className="formInputBox">
              <label htmlFor="blogDate" className={`formInputLabel`}>
                blog date
              </label>

              <input
                type="date"
                className={`formInput ${
                  formValues.blogDate ? "date-has-value" : ""
                } ${formErrors?.blogDate ? "formError" : ""}`}
                name="blogDate"
                value={formValues.blogDate}
                onChange={onChangeInput}
                max={currentMonthCurrentDate}
              />
            </div>

            <div className="formInputBox span4">
              <label htmlFor="blogContent" className="formInputLabel">
                blog content <span className="required">*</span>
              </label>

              <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
                <ReactQuillTextEditor
                  value={formValues.blogContent}
                  setValue={(content) =>
                    onChangeTextInput(content, "blogContent")
                  }
                  isError={formErrors?.blogContent}
                  loading={loading}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {aiGeneratedData && (
        <>
          <div className={`formInputsGrid uploadsInputGrids`}>
            <div className="formInputBox formInputUploadBox">
              <label htmlFor="blogImages" className="formInputLabel">
                cover Image <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper commonUploadWrapper no-border ${
                  formErrors?.blogImages ? "error" : ""
                }`}
                style={{ height: "auto" }}
              >
                <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                  <div className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="49"
                      height="49"
                      viewBox="0 0 49 49"
                      fill="none"
                    >
                      <path
                        d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                        fill="#A5A5A5"
                      />
                      <path
                        d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                        fill="#A5A5A5"
                      />
                    </svg>
                  </div>
                  <div className="image">
                    <ImageUploading
                      multiple
                      value={formImages.blogImages}
                      onChange={(imageList, _) =>
                        onChangeImages(imageList, "blogImages")
                      }
                      maxNumber={1}
                      dataURLKey="data_url"
                      acceptType={["jpg", "jpeg", "png", "webp"]}
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemoveAll,
                        onImageUpdate,
                        onImageRemove,
                        isDragging,
                        dragProps,
                      }) => (
                        <div className="upload__image-wrapper">
                          {formImages.blogImages?.length === 0 ? (
                            <>
                              <button
                                type="button"
                                style={
                                  isDragging ? { color: "red" } : undefined
                                }
                                onClick={onImageUpload}
                                {...dragProps}
                              >
                                Upload
                              </button>
                              &nbsp;
                            </>
                          ) : (
                            <>
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      onClick={() => onImageUpdate(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        onImageRemove(index);
                                        handleImageRemove(index);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      )}
                    </ImageUploading>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <div
                className={`commonWrapper commonSwitchWrapper no-border ${
                  formErrors?.isActive ? "formError" : ""
                }`}
              >
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={`${formValues.isActive ? "Active" : "Not Active"}`}
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>
        </>
      )}

      <div className="formButtons" style={{ justifyContent: "flex-end" }}>
        {aiGeneratedBlogLoading ? (
          <div className="flexEnd loader-with-info">
            <Loader />
            <span className="info-loading">
              Wait! This may take few seconds.
            </span>
          </div>
        ) : (
          <>
            {aiGeneratedData ? (
              <Button
                type="button"
                className="saveBtn"
                variant="dark"
                onClick={handleClearGenerateBlog}
                style={{ background: "black" }}
              >
                Clear Data
              </Button>
            ) : (
              <Button
                type="button"
                className="saveBtn"
                variant="danger"
                onClick={handleGenerateBlog}
              >
                Generate Blog
              </Button>
            )}
          </>
        )}
      </div>
    </form>
  );
};

export default BlogFormAIGenerated;
